import React from 'react';
import type { DataAnnotationAdditionalContent } from '../../../../lib';

interface AdditionalItemProps {
  title: string;
  item: DataAnnotationAdditionalContent;
}
const AdditionalItem = ({ title, item }: AdditionalItemProps) => {
  const itemValue: string = React.useMemo(() => {
    if (Object.values(item).length === 0) {
      return '';
    }

    const value = item.value;
    return value;
  }, [item]);

  return (
    <div className="d-flex flex-column gap-4">
      <span className="font-weight-600 font-16">{title}</span>
      <span className="roboto font-weight-400 font-14 color-grey">
        {itemValue?.split('\n').map((line, idx) => (
          <React.Fragment key={idx}>
            {line}
            {idx < itemValue?.split('\n').length - 1 && <br />}
          </React.Fragment>
        ))}
      </span>
    </div>
  );
};

export default AdditionalItem;
